import AMapMarker from './a-map-marker'

export default AMapMarker